var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification-bar",class:_vm.notificationTypeClass},[_c('v-chip',{attrs:{"label":"","text-color":"white","color":"#0066A1"}},[_c('h3',[_vm._v(_vm._s(_vm.notification.message))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }